import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import CreateSvg from '../../images/icons/create.svg?react';

type Props = {
  forDropdown?: boolean;
  forNavPill?: 'left' | 'right';
  clickHandler?: () => void;
};

export const CreateACartBlock = ({ forDropdown, forNavPill, clickHandler }: Props) => {
  const { t } = useTranslation();

  const className = forNavPill
    ? 'group inline-flex items-center gap-2 whitespace-nowrap bg-primary-off px-5 py-2 font-secondary font-bold text-sm md:text-base text-offWhite hover:bg-primary-offHover transition-all active:scale-[97%]'
    : forDropdown
    ? 'group inline-flex flex-row flex-nowrap items-center justify-start gap-2 whitespace-nowrap transition-all active:scale-[97%] h-7 w-full rounded-md px-1 py-0.5 text-primary hover:bg-gray-300/60'
    : 'group inline-flex flex-row flex-nowrap items-center justify-start gap-2 whitespace-nowrap transition-all active:scale-[97%] w-fit px-1 py-1 text-skyBlue hover:text-white';

  return (
    <NavLink to='/make' reloadDocument onClick={clickHandler} className={className}>
      <CreateSvg
        width={forDropdown ? 18 : 20}
        title='Create Cart Icon'
        style={forNavPill ? { fill: '#F1B820' } : undefined}
        className={`${
          forDropdown ? 'fill-primary pt-0.5' : forNavPill ? '' : 'fill-skyBlue group-hover:fill-white'
        } transition-all`}
      />
      {forNavPill ? t('common.create') : t('common.create_a_cart')}
    </NavLink>
  );
};
